// extracted by mini-css-extract-plugin
export var actions = "_f8-d";
export var benefitCard = "_f8-a";
export var benefitIcon = "_f8-b";
export var benefitLabel = "_f8-c";
export var benefits = "_f8-9";
export var bodyText = "_f8-8";
export var closeButton = "_f8-2";
export var content = "_f8-3";
export var eyebrow = "_f8-4";
export var heading = "_f8-5";
export var image = "_f8-f";
export var imagePanel = "_f8-e";
export var modal = "_f8-0";
export var shell = "_f8-1";
export var title = "_f8-6";
export var titleOffer = "_f8-7";